import { z } from "../wire/zod";

export const getServerInfoResponseSchema = z.object({
  majorAPIVersion: z.string(),
  minorAPIVersion: z.string(),
  time: z.number(),
});
